import { AuthState } from "./interface";

export const AUTH_INITIAL_STATE: AuthState = {
  authentication: {
    isAuthenticated: false,
    hasAcceptedTerms: false,
    session: null,
    user: null,
  },
  authorization: {
    isAuthorized: false,
    permissions: [],
  },
};
